import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import RouterWrapper from './components/RouterWrapper';
import ScrollToTop from './components/ScrollToTop';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SolutionsPage from './pages/SolutionsPage';
import AboutUsPage from './pages/AboutUsPage';
import ProductPage from './pages/ProductPage';
import ContactPage from './pages/ContactPage';
import PortfoliosPage from './pages/PortfoliosPage';
import BlogPage from './pages/blog';
import BlogDetailPage from './pages/blog/[slug]';
import SolutionDetailPage from './pages/SolutionDetailPage';
import DownloadsPage from './pages/DownloadsPage';
import DemoPage from './pages/DemoPage';
import HRMSPricePage from './pages/HRMSPricePage';
import NotFoundPage from './pages/NotFoundPage';

const App: React.FC = () => {
  return (
    <RouterWrapper>
      <HelmetProvider>
        <ScrollToTop />
        <GlobalStyles />
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/home" element={<Navigate to="/" replace />} />
              <Route path="/index.html" element={<Navigate to="/" replace />} />
              <Route path="/about" element={<Navigate to="/about-us" replace />} />
              <Route path="/about-us" element={<AboutUsPage />} />
              <Route path="/solutions" element={<SolutionsPage />} />
              <Route path="/pricing" element={<Navigate to="/products/hrms" replace />} />
              <Route path="/downloads" element={<DownloadsPage />} />
              <Route path="/products/hrms-price" element={<HRMSPricePage />} />
              <Route path="/products/:productSlug" element={<ProductPage />} />
              <Route path="/solutions/:solutionSlug" element={<SolutionDetailPage />} />
              <Route path="/portfolios" element={<PortfoliosPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogDetailPage />} />
              <Route path="/demo" element={<DemoPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </HelmetProvider>
    </RouterWrapper>
  );
};

export default App;
